import { useTranslation } from 'react-i18next'

import { lightPalette } from '../palette'
import { Eyebrow } from './Eyebrow'

export function HowItWorks() {
  const { t } = useTranslation()

  const steps = [
    {
      number: t('landing.howItWorks.step1Number'),
      title: t('landing.howItWorks.step1Title'),
      desc: t('landing.howItWorks.step1Desc'),
    },
    {
      number: t('landing.howItWorks.step2Number'),
      title: t('landing.howItWorks.step2Title'),
      desc: t('landing.howItWorks.step2Desc'),
    },
    {
      number: t('landing.howItWorks.step3Number'),
      title: t('landing.howItWorks.step3Title'),
      desc: t('landing.howItWorks.step3Desc'),
    },
    {
      number: t('landing.howItWorks.step4Number'),
      title: t('landing.howItWorks.step4Title'),
      desc: t('landing.howItWorks.step4Desc'),
    },
  ]

  return (
    <section id="como" style={{ maxWidth: 1200, margin: '0 auto', padding: '88px 24px' }}>
      <div
        data-reveal=""
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
          maxWidth: 620,
          marginBottom: 44,
        }}
      >
        <Eyebrow>{t('landing.howItWorks.eyebrow')}</Eyebrow>
        <h2
          style={{
            margin: 0,
            fontSize: 'clamp(28px,3.2vw,40px)',
            lineHeight: 1.1,
            fontWeight: 600,
            letterSpacing: '-0.035em',
          }}
        >
          {t('landing.howItWorks.title')}
        </h2>
        <p style={{ margin: 0, fontSize: 16.5, lineHeight: 1.6, color: lightPalette.textBody }}>
          {t('landing.howItWorks.subtitle')}
        </p>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(230px,1fr))',
          gap: 0,
          border: `1px solid ${lightPalette.borderDefault}`,
          borderRadius: 18,
          background: lightPalette.surface,
          overflow: 'hidden',
        }}
      >
        {steps.map((step, index) => (
          <div
            key={step.number}
            data-reveal=""
            style={{
              padding: 28,
              borderRight:
                index < steps.length - 1 ? `1px solid ${lightPalette.borderSofter}` : undefined,
              display: 'flex',
              flexDirection: 'column',
              gap: 11,
            }}
          >
            <span
              style={{
                fontFamily: "'JetBrains Mono',monospace",
                fontSize: 12,
                color: lightPalette.brandAccent,
              }}
            >
              {step.number}
            </span>
            <span style={{ fontSize: 16.5, fontWeight: 700 }}>{step.title}</span>
            <span style={{ fontSize: 14, lineHeight: 1.6, color: lightPalette.textBody }}>
              {step.desc}
            </span>
          </div>
        ))}
      </div>
    </section>
  )
}
